export const DEFAULT_TRIAL_PERIOD_DURATION_DAYS = 14;
